"use client"

import { CheckCircle, Info, CircleNotch, XCircle, Warning } from "@phosphor-icons/react";
import { useTheme } from "@/shared/lib/theme"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  // The app's own face (light/dark, time-of-day aware) — NOT next-themes,
  // which had no provider mounted here and so always answered "system".
  const { mode } = useTheme()

  return (
    <Sonner
      theme={mode}
      className="toaster group"
      icons={{
        success: <CheckCircle className="size-4" />,
        info: <Info className="size-4" />,
        warning: <Warning className="size-4" />,
        error: <XCircle className="size-4" />,
        loading: <CircleNotch className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
